import type { ScheduleConfig } from './schedule';

export interface LeagueScheduleConfig extends ScheduleConfig {
    conference: boolean;
}

const DAILY: LeagueScheduleConfig = { schedule: 'daily', conference: false };
const DAILY_CONFERENCE: LeagueScheduleConfig = { schedule: 'daily', conference: true };
const MONTHLY: LeagueScheduleConfig = { schedule: 'monthly', conference: false };
const MONTHLY_CONFERENCE: LeagueScheduleConfig = { schedule: 'monthly', conference: true };

const LEAGUE_SCHEDULES: Record<string, LeagueScheduleConfig> = {
    nfl: { schedule: 'weekly', conference: false, weekStart: 4 },
    ncaaf: { schedule: 'weekly', conference: true, weekStart: 4 },
    ncaab: DAILY_CONFERENCE,
    wncaab: DAILY_CONFERENCE,
    ncaabb: DAILY_CONFERENCE,
    ncaah: DAILY_CONFERENCE,
    soc: MONTHLY_CONFERENCE,
    wc: MONTHLY_CONFERENCE,
    nascar: MONTHLY,
    wwe: MONTHLY,
    yachting: MONTHLY,
    lemans: MONTHLY,
    boxing: MONTHLY,
    f1: MONTHLY,
    golf: MONTHLY,
    horseracing: MONTHLY,
    imsa: MONTHLY,
    lpga: MONTHLY,
    motogp: MONTHLY,
    nascarsprint: MONTHLY,
    nascarcamping: MONTHLY,
    nascarnationwide: MONTHLY,
    pga: MONTHLY,
    poker: MONTHLY,
    skiing: MONTHLY,
    summergames: MONTHLY,
    tennis: MONTHLY,
    indycar: MONTHLY,
};

const SOCCER_LEAGUES = ['soc', 'wc'];
const SOCCER_SPORT = 'SOC';

export function getScheduleConfig(leagueAbbr: string): LeagueScheduleConfig {
    return LEAGUE_SCHEDULES[leagueAbbr] ?? DAILY;
}

export function isSoccerLeague(leagueAbbr: string): boolean {
    return SOCCER_LEAGUES.includes(leagueAbbr);
}

export function isSoccerSport(league?: ContentfulLeague): boolean {
    return league?.fields.sport?.fields.abbreviation === SOCCER_SPORT;
}
